// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-header{margin-top:4px;margin-bottom:0px;font-size:12px;color:#606060}
`, "",{"version":3,"sources":["webpack://./src/app/components/LabelInput/styles.scss"],"names":[],"mappings":"AAAA,YACE,cAAe,CACf,iBAAkB,CAClB,cAAe,CACf,aAAc","sourcesContent":[".sub-header {\n  margin-top: 4px;\n  margin-bottom: 0px;\n  font-size: 12px;\n  color: #606060;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
